'use client'

import ReactSelect from 'react-select'
import { CField } from '@/_components/CField'
import { IOption } from '@/_types'
import { customStyles } from '../branch-select/async-select'
import { ITableOption } from '../index.legacy'

interface FormSelectProps {
  label: string
  value: IOption | null
  options: ITableOption[]
  onChange: (option: IOption | null) => void
  isDisabled?: boolean
  isLoading?: boolean
}

export default function FormSelect({
  label,
  value,
  options,
  onChange,
  isDisabled = false,
  isLoading = false,
}: FormSelectProps) {
  const Select = ReactSelect as React.ComponentType<any>

  return (
    <CField label={label} bgColor='background'>
      <Select
        instanceId={label}
        value={value}
        options={options}
        onChange={(opt: IOption | null) => onChange(opt)}
        isDisabled={isDisabled || isLoading}
        isLoading={isLoading}
        isOptionDisabled={(option: ITableOption) => Boolean(option.isDisabled)}
        styles={customStyles({ color: 'var(--text-default)' })}
        menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
        menuPosition='fixed'
      />
    </CField>
  )
}
